const isPositiveInteger = (integer) => {
  const result = Number(integer)
  // eslint-disable-next-line
  return Number.isInteger(result) && integer > 0
}

export default isPositiveInteger
